// @flow
import React from 'react'
import styled from 'styled-components'
import Agent from '../../../../types'
import Button from '../../../../components/Button'
import Card from '../../../../components/Card'

const Row = styled.div`
  display: flex;
  align-items: center;
`

type Props = {
  agent: Agent,
  openContactModal: func
}

const AgentData = ({ agent, openContactModal }: Props) => (
  <Card style={{ marginBottom: '2rem' }}>
    <Row className="row">
      <div className="col-sm-7 col-xs-12">
        <h3>{agent.name}</h3>
        <div style={{ marginBottom: '1rem' }}>
          <small>{agent.titles[0]}</small>
        </div>
        <Button
          type="button"
          color="primary"
          onClick={() => openContactModal({ to: agent.email })}
        >
          Contact Broker
        </Button>
      </div>
      <div className="col-sm-5 col-xs-12">
        {agent.image && (
          <img src={agent.image} alt={agent.name} style={{ width: '100%' }} />
        )}
      </div>
    </Row>
  </Card>
)

export default AgentData



// WEBPACK FOOTER //
// ./src/views/Property/components/AgentData/index.js